module.exports = __webpack_public_path__ + "img/illu-home.c000f9f6.svg";